// extracted by mini-css-extract-plugin
export default {"body":"CertificateSettings_body__cU96z","powerOfAttorney":"CertificateSettings_powerOfAttorney__YfLpm","powerOfAttorney_button":"CertificateSettings_powerOfAttorney_button__UomVu"};